import React from 'react';

function ProfileInstall(){

    return (
       
        <>

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Installer Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="email"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Email"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">


    <div class="col-sm-6">


          <div className="">
        
            <input
            type="tel"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Phone"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="tell"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Alternate Phone "
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">
<hr style={{marginTop:"50px", marginBottom:"50px"}} />
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Battery Information </strong></p>
    </div>
</div>

    <div class="col-sm-6">


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm ProgressFormSelect"
            name=""
            placeholder="Bank Name"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Inveter"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>

<div class="row">

<div class="col-sm-12">

</div>

    <div class="col-sm-6">


          <div className="">
        
          <select  id="cars" name="cars" className="Login-form-field Login-animation a4 ProgressForm selectForm" style={{ marginTop: "10px" }}>
          <option value="" disabled selected>Battery Model</option>
    <option value="Z-Range">Z-Range</option>
    <option value="Giga-Rack">Giga Rack</option>
  </select>

  

        </div>
    </div>

    <div class="col-sm-6">
          <div className="">
         
            <input
            type="text"
            className="Login-form-field Login-animation a4 ProgressForm"
            name=""
            placeholder="Serial Number"
            style={{ marginTop: "10px" }}
            />
        </div>
    </div>

</div>
        </>
    )
}

export default ProfileInstall;


